<template>
  <div class="record-text">
    <!-- 表情，文字 -->
    <div class="text-content" v-if="_elements.MsgType == 'TIMTextElem'">
      <template v-for="(item, index) in contentList">
        <span v-if="item.name === 'text'" class="texts" v-html="item.text"></span>
        <img v-else-if="item.name === 'img'" :src="item.src" width="20" height="20" />
      </template>
    </div>
    <!-- 图片 -->
    <div class="img-content" v-else-if="_elements.MsgType == 'TIMImageElem'">
      <el-image style="width: 100px;" :src="pic" :preview-src-list="[pic]">
      </el-image>
    </div>
    <!-- 文件 -->
    <div class="file-content" v-else-if="_elements.MsgType == 'TIMFileElem'">
      <div title="Clique para baixar" @click.stop="downloadFile">
        <div class="file-element">
          <div class="col-1">
            <i class="el-icon-document"></i>
          </div>
          <div class="col-2">
            <div>{{ fileName }}</div>
            <div>{{ fileSize }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- mp4视频 -->
    <div class="video-content" v-else-if="_elements.MsgType == 'TIMVideoFileElem'">
      <video :src="videoUrl" controls class="video" @error="videoError" @click.stop></video>
    </div>
    <!-- 自定义消息 -->
    <div class="wrapper" v-else-if="_elements.MsgType == 'TIMCustomElem'">
      <messageRecordReplyElement :message="this._elements.MsgContent" v-if="customType == 'reply'" />
      <div class="file" v-else-if="customType == 'file'">
        <a :href="Desc.payload.description" target="_blank">{{ Desc.payload.description }}</a>
      </div>
      <!-- mp4视频 -->
      <div class="video-content" v-else-if="customType == 'video'">
        <video :src="Desc.payload.description" controls class="video" @error="videoError" @click.stop></video>
      </div>
      <!-- mp4视频 -->
      <div class="video-content" v-else-if="customType == 'image'">
        <el-image :src="Desc.payload.description" style="width: 300px;"
          :preview-src-list="[Desc.payload.description]"></el-image>
      </div>
      <!-- 订单消息 -->
      <orderElement v-else-if="customType == 'order'" :isMine="false" :message="Desc" />
      <!-- 订单详情消息 -->
      <orderDetailElement v-else-if="customType == 'orderDetail'" :isMine="false" :message="Desc" />
      <!-- 问题产品详情消息 -->
      <problemOfGoodslElement v-else-if="customType == 'problemOfGoods'" :isMine="false" :message="Desc" />
      <!-- 产品详情消息 -->
      <productElement v-else-if="customType == 'product'" :isMine="false" :message="Desc" />
    </div>
  </div>
</template>
<script>
import { decodeText } from "./js/decodeText";
import messageRecordReplyElement from "./messageRecordReplyElement";
import orderElement from "./order-element.vue";
import orderDetailElement from "./orderDetail-element.vue";
import problemOfGoodslElement from "./problemOfGoods-element.vue";
import productElement from "./product-element.vue";
export default {
  props: {
    _elements: {
      MsgType: Object,
    },
  },
  components: {
    messageRecordReplyElement,
    orderElement,
    orderDetailElement,
    problemOfGoodslElement,
    productElement,
  },
  computed: {
    Desc() {
      let datas = {
        payload: { description: this._elements.MsgContent.Desc },
      };
      return datas;
    },
    customType() {
      if (this._elements.MsgType == "TIMCustomElem") {
        return this._elements.MsgContent.Data;
      }
      return false;
    },
    pic() {
      return this._elements.MsgContent.ImageInfoArray[0].URL;
    },
    contentList() {
      return decodeText({ text: this._elements.MsgContent.Text });
    },
    fileName() {
      return this._elements.MsgContent.FileName;
    },
    fileUrl() {
      return this._elements.MsgContent.Url;
    },
    fileSize() {

      const size = this._elements.MsgContent.FileSize;
      if (size > 1024) {
        if (size / 1024 > 1024) {
          return `${this.toFixed(size / 1024 / 1024)} Mb`;
        } else {
          return `${this.toFixed(size / 1024)} Kb`;
        }
      }
      return `${this.toFixed(size)}B`;
    },
    videoUrl() {
      return this._elements.MsgContent.VideoUrl;
    },
  },
  data() {
    return {

    };
  },
  methods: {
    toFixed(size, precision = 2) {
      return size.toFixed(precision);
    },

    // 下载文件
    downloadFile() {
      // 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
      if (window.fetch) {
        fetch(this.fileUrl)
          .then((res) => res.blob())
          .then((blob) => {
            let a = document.createElement("a");
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = this.fileName;
            a.click();
          });
      } else {
        let a = document.createElement("a");
        a.href = this.fileUrl;
        a.target = "_blank";
        a.download = this.filename;
        a.click();
      }
    },
    //mp4错误信息
    videoError(e) {
      //   this.$store.commit('showMessage', { MsgType: 'error', message: '视频出错，错误原因：' + e.target.error.message })
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/css/mixin';

.record-text {
  padding-left: 5px;

  .text-content {
    color: #333333;
    word-wrap: break-word;
    word-break: break-all;
  }

  .img-content {
    .pic {
      height: 100px;
    }
  }

  .file-content {
    .file-element {
      display: flex;
      align-items: center;

      .col-1 {
        @include sc(40px, $primary-color);
        margin-right: 10px;
      }

      .col-2 {
        color: #666;
      }
    }
  }

  .video-content {
    .video {
      width: 300px;

    }
  }
}
</style>